import { render, staticRenderFns } from "./dialog-caleg.vue?vue&type=template&id=dc680a10&"
import script from "./dialog-caleg.vue?vue&type=script&lang=js&"
export * from "./dialog-caleg.vue?vue&type=script&lang=js&"
import style0 from "./dialog-caleg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "dialog-caleg.vue"
export default component.exports